import {createAction} from "redux-act";
import {IDictionary} from "modules/types";
import {
	IDrawPredictorSettings,
	IFanFact,
	IFanSentiments,
	IQualifierGroup,
	IQualifierSquad,
	ISquad,
} from "apps/DRAW_PREDICTOR/modules/reducers";

export const fetchSquadsJson = createAction();
export const fetchSquadsJsonSuccess = createAction<ISquad[]>();
export const fetchSquadsJsonFailed = createAction<Error["message"]>();

export const fetchSupportedCountriesJson = createAction();
export const fetchSupportedCountriesJsonSuccess = createAction<IDictionary<string>>();
export const fetchSupportedCountriesJsonFailed = createAction<Error["message"]>();

export const fetchFanSentimentsJson = createAction();
export const fetchFanSentimentsJsonSuccess = createAction<IFanSentiments>();
export const fetchFanSentimentsJsonFailed = createAction<Error["message"]>();

export const fetchSettingsJSON = createAction();
export const fetchSettingsJSONSuccess = createAction<IDrawPredictorSettings>();
export const fetchSettingsJSONFailed = createAction<Error["message"]>();

export const fetchFanFactsJSON = createAction();
export const fetchFanFactsJSONSuccess = createAction<IDictionary<IFanFact>>();
export const fetchFanFactsJSONFailed = createAction<Error["message"]>();

export const fetchQualifierGroupsJSON = createAction();
export const fetchQualifierGroupsJSONSuccess = createAction<IQualifierGroup[]>();
export const fetchQualifierGroupsJSONFailed = createAction<Error["message"]>();

export const fetchQualifierSquadsJSON = createAction();
export const fetchQualifierSquadsJSONSuccess = createAction<IQualifierSquad[]>();
export const fetchQualifierSquadsJSONFailed = createAction<Error["message"]>();
